// extracted by mini-css-extract-plugin
export default {"container":"info_container__MJFFj","heading":"info_heading__BThZM","text":"info_text__Q57He","imgContainer":"info_imgContainer__C1cRE"};